const fonts = {
  montserratRegular: "font-family: 'Montserrat Regular', Arial, sans-serif;",
  montserratMedium: "font-family: 'Montserrat Medium', Arial, sans-serif;",
  montserratBold: "font-family: 'Montserrat Bold', Arial, sans-serif;",
};

export default fonts;
